import moment from 'moment'
import type {
  LineItem,
  LineItemType,
  ClaimButton,
  QuoteData,
  IClaimButtonSummary,
  IStandardLineItemDTO,
} from './types'
import { LINE_ITEM_TYPE_ORDER } from './constants'

export function calculateTotal(lineItems: LineItem[]): number {
  return lineItems.reduce((sum, item) => sum + item.total, 0)
}

export function recalculateFinancials(quote: QuoteData): QuoteData {
  const totalOriginalCost = calculateTotal(quote.lineItems)
  const consumedCost = quote.consumedCost
  return { ...quote, totalOriginalCost, consumedCost }
}

export function groupLineItemsByType(
  lineItems: LineItem[]
): Record<LineItemType, LineItem[]> {
  const grouped: Record<LineItemType, LineItem[]> = {
    PC: [],
    TC: [],
    AN: [],
    PT: [],
    MI: [],
  }
  lineItems.forEach((item) => {
    grouped[item.type].push(item)
  })
  return grouped
}

export function sortLineItemsByType(lineItems: LineItem[]): LineItem[] {
  const grouped = groupLineItemsByType(lineItems)
  return LINE_ITEM_TYPE_ORDER.flatMap((type) => grouped[type])
}

export function formatCurrency(value: number): string {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
}

export function normalizeQuoteId(id?: string): string {
  return (id || '').toLowerCase()
}

export function mapClaimButton(
  btn: IClaimButtonSummary,
  type: LineItemType
): ClaimButton {
  return {
    id: btn.claimId || crypto.randomUUID(),
    name: btn.label || '',
    lineItemId: null,
    type,
    providerGroup: btn.providerGroup || '',
    dateOfService: btn.dateOfService
      ? moment(btn.dateOfService).format('MM/DD/YYYY')
      : '',
    originalBundleQuoteId: btn.originalBundleQuoteId,
    movedClaimInfo: btn.movedClaimInfo,
    appealTypeDescription: btn.appealTypeDescription,
    percentageLineItemsReconciled: btn.percentageLineItemsReconciled,
  }
}

export function mapStandardLineItem(
  item: IStandardLineItemDTO,
  index: number,
  type: LineItemType,
  prefix: string,
  itemType: string,
  providerType: string
): LineItem {
  return {
    id: item.id || `${prefix}-${index}-${crypto.randomUUID()}`,
    originalQuoteId: item.originalQuoteId,
    type,
    description: item.lineDescription || item.otherDescription || '',
    quantity: 1,
    cost: item.reconciledCost || item.cost || 0,
    total: item.reconciledCost || item.cost || 0,
    providerGroup: item.providerName || '',
    providerType,
    cptCode: item.cptCode,
    itemType,
    costSource: item.costSource,
    billedCharges: item.actualCost || 0,
    quotedAmount: item.cost || 0,
    reconciledAmount: item.reconciledCost || 0,
    reasonCode: item.reasonCode,
    movedToQuoteLegacyEOCGroupNumber: item.movedToQuoteLegacyEOCGroupNumber,
  }
}
